import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";

import "./Login.scss";
import { doSignInWithEmailAndPassword } from "../../services/firebase/auth";
import Warning from "../../components/_default/Warning";
import firebase from "firebase";
import Button from "../../components/_default/Button";
import Icon from "../../components/_default/Icon";
import UserContext from '../../services/context/userContext'
import video from "../../assets/video/background.mp4";

function Login({ ...props }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [wrongField, setWrongField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fbLoading, SetFbLoading] = useState(false);
  const [googleLoading, SetGoogleLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false)
  const history = useHistory();
  const user = useContext(UserContext)

  const onSubmit = () => {
    setLoading(true);
    var emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (emailRegex.test(email) === false) {
      setWrongField("This is not an email address.");
      setLoading(false);
      hideErrorPopup();
    } else if (password.length <= 0) {
      setWrongField("Invalid password");

      setLoading(false);
      hideErrorPopup();
    } else {
      setWrongField(false);
      firebase.analytics().logEvent(
        "login",
        doSignInWithEmailAndPassword(email, password, (callback) => {
          window.location = '/dashboard';
        })
      );
      doSignInWithEmailAndPassword(email, password, (callback) => {
        if (callback, callback.status && callback.status === "error") {
          setWrongField(callback.error.message);
          setLoading(false);
          hideErrorPopup();
          window.location = '/dashboard';
        }
      });
    }
  };

  useEffect(() => {
    if(user.error){
      setWrongField(user.message);
      hideErrorPopup();
    }
  },[user])

  const hideErrorPopup = () => {
    setTimeout(() => {
      setWrongField(false);
    }, 5000);
  };

  const handleUserKeyPress = (event) => {
    const { key, keyCode } = event;

    if (keyCode === 13) {
      onSubmit();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress]);

  function handleFacebookLogin() {
    SetFbLoading(true);
  }
  function handleGoogleLogin() {
    SetGoogleLoading(true);
  }

  return (
    <>
      <video autoPlay muted loop id="bg-video">
        <source src={video} type="video/mp4" />
      </video>
      <section className="c-login">
        <div className="c-login-wrapper">
          {/*<Button loading={fbLoading} onSubmit={() => handleFacebookLogin()} text="Sign in with Facebook" color="#fff" leftIcon="facebook" backgroundColor="#1578F2" />*/}
          {/* <Button loading={googleLoading} onSubmit={() => handleGoogleLogin()} text="Sign in with Google" leftIcon="google" backgroundColor="#F4F4F4" /> */}
          <h4>Sign in with E-mail</h4>
          <input className="c-input" type="text" placeholder="Email" onChange={(e) => setEmail(e.target.value)} onKeyUp={(e) => e.key === "Enter" ? onSubmit() : {}}/>
          <div className="pass-wrapper">
            <input className="c-input" type={passwordShown ? "text" : "password"} placeholder="Wachtwoord" onChange={(e) => setPassword(e.target.value)} onKeyUp={(e) => e.key === "Enter" ? onSubmit() : {}}/>
            <button onClick={() => setPasswordShown(!passwordShown)}>
              { passwordShown ?  <Icon icon="eye" color="#000"/> :  <Icon icon="eye" />}
            </button>
          </div>
          <Button className="c-login-btn" text="Login" loading={loading} onSubmit={() => onSubmit()} />
        </div>
      </section>
      <p className="c-forgot-link">
        Forgot password?{" "}
        <Link to={{ pathname: "/reset-password", resetEmail: email }}>Click here</Link>{" "}
        to recover
      </p>
      {wrongField && <Warning title="Something went wrong..." wrongField={wrongField} />}
    </>
  );
}

export default Login
